import { render, staticRenderFns } from "./AuthSetPassword.vue?vue&type=template&id=12157554&"
import script from "./AuthSetPassword.vue?vue&type=script&lang=js&"
export * from "./AuthSetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12157554')) {
      api.createRecord('12157554', component.options)
    } else {
      api.reload('12157554', component.options)
    }
    module.hot.accept("./AuthSetPassword.vue?vue&type=template&id=12157554&", function () {
      api.rerender('12157554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth/src/features/auth/screens/AuthSetPassword.vue"
export default component.exports